import React, { useState, useEffect } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';
import Select from '../../../components/ui/Select';

const SleepTimer = ({ 
  onTimerSet,
  onTimerCancel 
}) => {
  const [isActive, setIsActive] = useState(false);
  const [timeRemaining, setTimeRemaining] = useState(0);
  const [selectedDuration, setSelectedDuration] = useState('');

  const durationOptions = [
    { value: '5', label: '5 минут' },
    { value: '10', label: '10 минут' },
    { value: '15', label: '15 минут' },
    { value: '30', label: '30 минут' },
    { value: '45', label: '45 минут' },
    { value: '60', label: '1 час' }
  ];

  useEffect(() => {
    if (!isActive || timeRemaining <= 0) return;

    const interval = setInterval(() => {
      setTimeRemaining(prev => {
        if (prev <= 1) {
          setIsActive(false);
          onTimerSet(0);
          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(interval);
  }, [isActive, timeRemaining, onTimerSet]);

  const handleStartTimer = () => {
    if (selectedDuration) {
      const minutes = parseInt(selectedDuration);
      setTimeRemaining(minutes * 60);
      setIsActive(true);
      onTimerSet(minutes);
    }
  };

  const handleCancelTimer = () => {
    setIsActive(false);
    setTimeRemaining(0);
    setSelectedDuration('');
    onTimerCancel();
  };

  const formatTime = (seconds) => {
    const mins = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${mins}:${secs?.toString()?.padStart(2, '0')}`;
  };

  return (
    <div className="sleep-timer bg-card rounded-lg border border-border p-6">
      <div className="timer-header flex items-center gap-2 mb-4">
        <Icon name="Moon" size={20} color="var(--color-primary)" />
        <h3 className="text-lg font-heading font-semibold text-foreground">
          Таймер сна
        </h3>
      </div>

      {!isActive ? (
        <div className="timer-setup space-y-4">
          <Select
            label="Выберите время"
            placeholder="Выберите продолжительность"
            options={durationOptions}
            value={selectedDuration}
            onChange={setSelectedDuration}
          />

          <Button
            variant="default"
            fullWidth
            onClick={handleStartTimer}
            disabled={!selectedDuration}
            iconName="Play"
            iconPosition="left"
          >
            Запустить таймер
          </Button>
        </div>
      ) : (
        <div className="timer-active space-y-4">
          <div className="timer-display text-center py-6">
            <div className="text-4xl font-mono font-bold text-primary mb-2">
              {formatTime(timeRemaining)}
            </div>
            <p className="text-sm text-muted-foreground">
              до остановки воспроизведения
            </p>
          </div>

          <Button
            variant="destructive"
            fullWidth
            onClick={handleCancelTimer}
            iconName="X"
            iconPosition="left"
          >
            Отменить таймер
          </Button>
        </div>
      )}
    </div>
  );
};

export default SleepTimer;